import { useCallback, useEffect, useRef } from "react";

export const useTimeout = (expirationTime: number | null, callback: () => void) => {
  const timer = useRef<NodeJS.Timeout | undefined>(undefined);

  const clear = useCallback(() => {
    if (timer.current !== undefined) {
      clearTimeout(timer.current);
    }
  }, []);

  useEffect(() => {
    if (expirationTime === null) {
      return;
    }

    const now = Date.now();
    timer.current = setTimeout(callback, expirationTime - now);

    return () => {
      clear();
    };
  }, [callback, expirationTime, clear]);

  return clear;
};
